import {ChangeDetectorRef, Component, Inject, DOCUMENT, DestroyRef} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../../libs/kfp/src/lib/app-service/kfp.service';
import * as _moment from 'moment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs';


const moment = _moment;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(translate: TranslateService, appService: AppService, changeDetectorRef: ChangeDetectorRef,
                @Inject(DOCUMENT) private document: Document, private readonly destroyRef: DestroyRef,
                router: Router) {
        router.events.pipe(
            filter(e => e instanceof NavigationError),
            takeUntilDestroyed(this.destroyRef),
        ).subscribe((event: NavigationError) => {
            const msg: string = event.error?.message ?? '';
            if (msg.includes('Importing a module script failed') || msg.includes('Failed to fetch dynamically imported module')) {
                window.location.assign(event.url);
            }
        });
        translate.addLangs(['cz']);
        translate.setDefaultLang('cz');
        translate.use('cz');
        if (localStorage.getItem('color')) {
            appService.changePrimaryColor(localStorage.getItem('color'));
            changeDetectorRef.markForCheck();
        } else {
            appService.changePrimaryColor('#e84e0e');
            changeDetectorRef.markForCheck();
        }

        if (localStorage.getItem('color2')) {
            appService.changePrimary2Color(localStorage.getItem('color2'));
            changeDetectorRef.markForCheck();
        } else {
            appService.changePrimary2Color('#002b4f');
            changeDetectorRef.markForCheck();
        }
        this.setMomentLocalization();

        translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: LangChangeEvent) => {
            this.setMomentLocalization(event.lang);
            console.log('onLangChange: ', event.lang);
            this.document.documentElement.lang = event.lang;
        });

        // https://github.com/moment/moment/issues/6153
    }

    setMomentLocalization(lang = 'cz'): void {
        moment.locale(lang === 'cz' ? 'cs' : lang);
        const upMonths = moment.months().map((m) => {
            return m.charAt(0).toUpperCase() + m.slice(1);
        });
        moment.updateLocale(lang === 'cz' ? 'cs' : lang, {
            months: upMonths,
        });
    }
}
